import { NgModule } from '@angular/core';
import { FiChecklistCheckpointMandatoryInfo } from './checkpoint-mandatory-info.component';
import { FiChecklistSectionsDirective } from './checklist-sections.directive';

@NgModule({
    declarations: [FiChecklistCheckpointMandatoryInfo, FiChecklistSectionsDirective],
    exports: [FiChecklistCheckpointMandatoryInfo, FiChecklistSectionsDirective],
})
export class FiChecklistCommonModule {}
